import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import styles from "./FlavourRating.module.scss";
export const FlavourRating = ({ rating, label }) => {
    return (_jsxs("div", { className: styles.ratingRow, children: [_jsx("div", { className: styles.label, children: label }), _jsx("div", { className: styles.flavourRating, children: Array.from({ length: 5 }).map((_, index) => {
                    const ratingDotValue = index + 1;
                    return (_jsx("span", { className: classNames(styles.ratingDot, {
                            [styles.ratingDotActive]: ratingDotValue <= rating,
                            [styles.ratingDotHalf]: ratingDotValue - 0.5 === rating,
                        }) }, index));
                }) })] }));
};
//# sourceMappingURL=FlavourRating.js.map